module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "questionTray"
  }, [_c('div', {
    ref: "questions",
    staticClass: "questions"
  }, [_c('ul', {
    staticClass: "questionList"
  }, _vm._l((_vm.filteredQuestions), function(question, index) {
    return _c('questionbox', {
      key: index,
      attrs: {
        "question": question,
        "person": _vm.getPerson(index),
        "peopleMap": _vm.peopleMap,
        "user": _vm.user
      },
      on: {
        "openPersonCard": function($event) {
          _vm.openPersonCard($event)
        },
        "showChildAtPosition": _vm.showChildAtPosition
      }
    })
  })), _vm._v(" "), (_vm.isEmpty) ? _c('div', {
    staticClass: "background-message"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('str.NoQuestionsAsked')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "questionSubmit"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questionText),
      expression: "questionText"
    }],
    staticClass: "questionText",
    attrs: {
      "maxlength": "500",
      "placeholder": _vm.$t('str.EnterYourQuestionHere')
    },
    domProps: {
      "value": (_vm.questionText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitQuestion($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.questionText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "chars"
  }, [_vm._v(" " + _vm._s(_vm.questionText.length) + " / 500 ")]), _vm._v(" "), _c('img', {
    staticClass: "submitButton",
    attrs: {
      "src": require("../../assets/icons/enter_white.svg")
    },
    on: {
      "click": _vm.submitQuestion
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "question-text-arrow"
  }), _vm._v(" "), (this.viewPerson) ? _c('personcard', {
    attrs: {
      "attendee": this.viewPerson,
      "user": _vm.user
    },
    on: {
      "cardClosed": _vm.personCardClosed
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2055e066","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/question/QuestionTray.vue
// module id = 464
// module chunks = 0